import React, { FC, createRef, useState } from "react";
import MagicDropzone from "react-magic-dropzone";

// import { resizeImage } from "../../utils/resizeImage";

const Form: FC<{
  values: {
    address: string;
    city: string;
    zipcode: number;
    state: string;
    photo_id: string;
  };
  setValues: React.Dispatch<
    React.SetStateAction<{
      address: string;
      city: string;
      state: string;
      zipcode: number;
      photo_id: string;
    }>
  >;
}> = (props): JSX.Element => {
  const canvasRef = createRef<HTMLCanvasElement>();
  const [preview, setPreview] = useState("");

  const handleChange = (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ): void => {
    const { name, value } = event.target;

    props.setValues({
      ...props.values,
      [name]: name === "zipcode" ? ~~value : value,
    });
  };

  const onDrop: (accepted: any, _rejected: any, _links: any) => void = (
    accepted,
    _rejected,
    _links
  ): void => {
    const xhr: XMLHttpRequest = new XMLHttpRequest();
    xhr.responseType = "blob";

    xhr.onload = async (): Promise<void> => {
      const recoveredBlob: any = xhr.response;
      let img: string = URL.createObjectURL(recoveredBlob);

      setPreview(img);
      await props.setValues({ ...props.values, photo_id: img });
    };

    xhr.open("GET", accepted[0].preview);
    xhr.send();
  };

  return (
    <div className="face">
      <div className="content">
        <br />
        <h2 className="flex flex-col justify-center align-center items-center text-lg">
          <b>
            Please complete the following form for identification purposes.
          </b>
        </h2>
        <br />
        <div className="flex flex-col justify-center align-center items-center">
          <div className="field-wrapper">
            <label>Address</label>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <input
              type="text"
              name="address"
              onChange={handleChange}
              value={props.values.address}
              required
              className="bg-gray-400 text-black"
            />
          </div>
          <br />
          <div className="flex flex-col flex-wrap justify-center items-center align-center">
            <p className="mb-4 px-24 text-red-600">
              Please do not use these symbols in the address field: ? # $ ! - +
              ( ) % = / \
            </p>
          </div>

          <br />
          <div className="field-wrapper">
            <label>City</label>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <input
              type="text"
              name="city"
              onChange={handleChange}
              value={props.values.city}
              required
              className="bg-gray-400 text-black"
            />
          </div>
          <br />
          <div className="field-wrapper">
            <label>State</label>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <input
              type="text"
              name="state"
              onChange={handleChange}
              value={props.values.state}
              required
              className="bg-gray-400 text-black"
            />
          </div>
          <br />
          <div className="field-wrapper">
            <label>ZipCode</label>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <input
              type="number"
              name="zipcode"
              minLength={5}
              maxLength={5}
              onChange={handleChange}
              value={`${props.values.zipcode}`}
              required
              className="bg-gray-400 text-black"
            />
          </div>
        </div>
        <br />
        <div className="field-wrapper flex flex-col flex-wrap justify-center items-center align-center">
          <label className="mb-4 px-24 text-red-600">
            <b>
              Validation: You must upload a photo of your Government Issued ID
              or High School Student ID to verify you. This image will be used
              for validation, and deleted after your photo has been approved.
            </b>
          </label>
          <MagicDropzone
            className="Dropzone"
            accept="image/jpeg, image/png, .jpg, .jpeg, .png"
            multiple={false}
            onDrop={onDrop}
          >
            {preview ? (
              <img
                alt="upload preview"
                className="Dropzone-img"
                src={preview}
              />
            ) : (
              <span>
                Click in this area to upload your <br /> Government ID of High
                School ID.
              </span>
            )}
            <canvas id="canvas" ref={canvasRef} />
          </MagicDropzone>
        </div>
        <br />
      </div>
    </div>
  );
};

export default Form;
